module.exports = __webpack_public_path__ + "static/SalesLive-df7ab50947362982f3d2a2c6d92474d4.png";